import React, { Component } from 'react';
import { observer, PropTypes as MobxPropTypes } from 'mobx-react';
import Panel from './WhitelistingPanel';

@observer
export default class WhitelistingSection extends Component {
  static propTypes = {
    ui: MobxPropTypes.observableObject,
    store: MobxPropTypes.observableObject,
  };

  render() {
    const { ui, sale, whitelisting, user } = this.props;
    return (
      ui.currentPanel === 'whitelisting' && (
        <Panel
          isOpen={true}
          whitelisting={whitelisting}
          sale={sale}
          user={user}
          onClose={() => ui.closePanel()}
        />
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Sale/WhitelistingSection/index.jsx